import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiDataService } from 'src/app/api/services/api-data.service';
import { GridDataProvider } from 'src/app/controls/grid/services/grid-data-provider.interface';
import { StageCardService } from '../../competition-management/edit-competition-card/edit-stage-card/service/stage-card.service';
import { StageResultList } from '../models/stage-result-list.interface';
import { SelectedItem } from 'src/app/controls/models/selected-item.interface';
import { ColumnDefinition } from 'src/app/controls/grid/models/column-definition.interface';
import { ResultsService } from 'src/app/controls/base/results.service';

@Injectable()
export class StageResultsTableService implements GridDataProvider, ResultsService {
  
  /** Api data service reference */
  private service = inject(ApiDataService);

  /** Stage service reference */
  private stageService = inject(StageCardService);
  
  /** @inheritdoc */
  public getTableName(stageId: number): Observable<string> {
    return this.stageService.getName(stageId);
  }

  /** @inheritdoc */
  public getGridData(stageId: number): Observable<StageResultList[]> {
    return this.service.getAll<StageResultList>('stage-results/stage/' + stageId);
  }

  /** @inheritdoc */
  public getColumnDefinition(stageId: number): Observable<ColumnDefinition[]> {
    return this.service.getAll<ColumnDefinition>('stage-results/column-definition/' + stageId);
  }

  /**
   * Gets all available crews for creating a new stage result
   * @param stageId the id of desired stage
   * @returns the list of available crews
   */
  public getAvailableCrews(stageId: number): Observable<SelectedItem[]> {
    return this.service.getAll<SelectedItem>('stage-results/available-crews/' + stageId);
  }

  /**
   * Recalculates the stage results
   * @param id the stage id reference
   */
  public recalculateResults(id: number): Observable<void> {
    return this.service.patchEmpty<void>('stage-results/recalculate/' + id);
  }

  /** @inheritdoc */
  public getDisplayResultsStatus(id: number): Observable<boolean> {
    return this.stageService.getDisplayResultsStatus(id);
  }

  /** @inheritdoc */
  public updateResultsStatus(id: number): Observable<void> {
    return this.stageService.updateResultsStatus(id);
  }

  /**
   * Gets the stage result by id
   * @param id the id of desired stage result
   */
  public getResult(id: number): Observable<StageResultList> {
    return this.service.get<StageResultList>('stage-results/get/' + id);
  }
}
